module.exports = __webpack_public_path__ + "static/media/_plus.2fb5ab0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_plus.jpg
// module id = 61
// module chunks = 0